import React from "react";
import BaseModal from "../../components/BaseModal";
import { useTranslation } from "react-i18next";
import { MODAL_TYPES } from "../../utils/emitter";
import BaseButton from "../../components/BaseButton";
import ManFace from "../../assets/images/man_face_quality.png";
import WomanFace from "../../assets/images/woman_face_quality.png";
import useBrowserStorage from "../../hooks/useBrowserStorage";
import { CURRENT_TEMP_DEMO_GENDER } from "../../utils/constants";
import useModalActions from "../../hooks/useModalActions";
import PersonalAccount from "../../store/PersonalAccount";
import "./style.scss";

export default function ChooseYourGenderModal() {
  const { t } = useTranslation();
  const { closeModal } = useModalActions();
  const { setItem } = useBrowserStorage();

  const selectGender = (gender) => {
    setItem(CURRENT_TEMP_DEMO_GENDER, gender);
    PersonalAccount.setUser({ gender });
    closeModal(MODAL_TYPES.CHOOSE_YOUR_GENDER);
  };

  return (
    <BaseModal
      preventClose
      className="choose-gender-faces-modal"
      eventTypeModal={MODAL_TYPES.CHOOSE_YOUR_GENDER}
      title={t("chooseYourGender")}
      titleStyle="choose-gender-faces-modal__title"
      contentStyle="choose-gender-faces-modal__content"
    >
      <div className="choose-gender-faces">
        <img
          className="choose-gender-faces__face"
          src={ManFace}
          alt="man-face"
        />
        <img
          className="choose-gender-faces__face"
          src={WomanFace}
          alt="woman-face"
        />
      </div>
      <BaseButton onClick={() => selectGender("male")} unfilledWhite>
        {t("men")}
      </BaseButton>
      <BaseButton onClick={() => selectGender("female")} unfilledWhite>
        {t("women")}
      </BaseButton>
    </BaseModal>
  );
}
